import { format, isFirstDayOfMonth, isLastDayOfMonth } from 'date-fns';
import { MONTH_TRANSLATION_KEYS, } from '../models';
import { getValidityDateLabel } from './validityDateFormatterService';
export function hideZeroAmountInPackMobileDivisions(coverDetail) {
    const hasAddressDivision = coverDetail.divisions.some((division) => division.type === 'address');
    return hasAddressDivision
        ? Object.assign(Object.assign({}, coverDetail), { divisions: coverDetail.divisions.filter((division) => division.type !== 'mobile' ||
                (division.type === 'mobile' &&
                    division.summaryCategories &&
                    hasNonZeroSummaryCategories(division.summaryCategories))) }) : coverDetail;
}
const hasNonZeroSummaryCategories = ({ usage, oneTimeCharge, subscription, }) => Number(usage) !== 0 &&
    (oneTimeCharge === undefined || Number(oneTimeCharge) !== 0) &&
    (subscription === undefined || Number(subscription) !== 0);
export function getOdbExplanationScreensTranslations(hasNegativeTotalAmount, getTranslation, getTranslationIfKeyExists, category) {
    let title;
    let subtitle;
    let descriptionHtml;
    if (category === undefined) {
        title = getTranslation(hasNegativeTotalAmount
            ? 'bills.cover.explanation.inYourFavor.coverExplanationButtonLabel'
            : 'bills.cover.coverExplanationButtonLabel');
        subtitle = getTranslation(hasNegativeTotalAmount
            ? 'bills.cover.explanation.inYourFavor.subTitle'
            : 'bills.cover.explanation.subTitle');
        descriptionHtml = getTranslationIfKeyExists(hasNegativeTotalAmount
            ? 'bills.cover.explanation.inYourFavor.descriptionHtml'
            : 'bills.cover.explanation.descriptionHtml');
    }
    else {
        title = getTranslationIfKeyExists(`bills.cover.explanation.${category}.title`);
        subtitle = getTranslationIfKeyExists(`bills.cover.explanation.${category}.subtitle`);
        descriptionHtml = getTranslationIfKeyExists(`bills.cover.explanation.${category}.descriptionHtml`);
    }
    return {
        title,
        subtitle,
        descriptionHtml,
    };
}
export function getDivisionIdentifierLabel(type, translate, identifier) {
    var _a;
    return identifier || ((_a = translate(`bills.cover.identifierLabels.${type}`)) !== null && _a !== void 0 ? _a : type);
}
export function getCoverDetailItemTitle(identifier, category, divisionType, getTranslation) {
    let title = '';
    if (identifier) {
        title = identifier;
    }
    else if (category) {
        if (category !== 'usage') {
            title = getTranslation(`bills.common.categories.${category}`);
        }
        else {
            title = getTranslation(`bills.cover.usageTypes.${divisionType}`);
        }
    }
    else {
        title = getTranslation(`bills.cover.identifierLabels.${divisionType}`);
    }
    return title;
}
export function getSectionOrItemData(sectionOrItem, categoryDetailValidFor, getTranslation) {
    var _a;
    const { identifier, validFor, description, amount } = sectionOrItem;
    const title = description !== null && description !== void 0 ? description : identifier;
    const identifierSubtitle = title === identifier ? '' : identifier !== null && identifier !== void 0 ? identifier : '';
    const hasSameValidFor = (categoryDetailValidFor === null || categoryDetailValidFor === void 0 ? void 0 : categoryDetailValidFor.endDate) === (validFor === null || validFor === void 0 ? void 0 : validFor.endDate) &&
        (categoryDetailValidFor === null || categoryDetailValidFor === void 0 ? void 0 : categoryDetailValidFor.startDate) === (validFor === null || validFor === void 0 ? void 0 : validFor.startDate);
    const validityDateLabel = !hasSameValidFor ? getValidityDateLabel(validFor, getTranslation) : '';
    const delimitor = identifierSubtitle && validityDateLabel ? ' - ' : '';
    let subtitle = `${identifierSubtitle}${delimitor}${validityDateLabel}`;
    if ('note' in sectionOrItem) {
        subtitle = (_a = sectionOrItem.note) !== null && _a !== void 0 ? _a : subtitle;
    }
    return { title, subtitle, amount };
}
export function getCategoryDetailDisplayableDuration(validFor, category, translate) {
    if (validFor) {
        const startDate = new Date(validFor.startDate);
        const monthName = getMonthTranslationsByMonthNumber(startDate.getMonth(), translate);
        if (monthName) {
            if ('usage' === category ||
                (isFirstDayOfMonth(startDate) &&
                    validFor.endDate &&
                    isLastDayOfMonth(new Date(validFor.endDate)))) {
                return monthName;
            }
            else if (validFor.endDate === undefined) {
                return `${monthName} (${format(startDate, 'DD/MM')})`;
            }
            else if (validFor.endDate) {
                return `${monthName} (${format(startDate, 'DD/MM')} - ${format(validFor.endDate, 'DD/MM')})`;
            }
        }
    }
}
export function getMonthTranslationsByMonthNumber(monthNumber, translate) {
    return MONTH_TRANSLATION_KEYS.reduce((prev, item) => [...prev, translate(item)], [])[monthNumber];
}
